export default __webpack_public_path__ + "static/media/white_membershippass.65a689ed.svg";